import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { MediaImageWithMediaClient } from './mediaImage';
export var MediaImageWithErrorBoundary = function MediaImageWithErrorBoundary(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null, props.children({
      loading: false,
      error: true
    }))
  }, /*#__PURE__*/React.createElement(MediaImageWithMediaClient, props));
};